import React, { useContext, Suspense } from "react";
import DynamicLayout from "../components/DynamicLayout";
import { PlatformContext } from "../context/PlatformContext";
import { MobileComponents, DesktopComponents, LoadingComponent } from "../helpers/platformUtils";

const Index = () => {
  const { platform, loading } = useContext(PlatformContext);
  
  if (loading) {
    return (
      <DynamicLayout>
        <LoadingComponent />
      </DynamicLayout>
    );
  }

  const isMobile = platform === 'mobileApp' || platform === 'mobileWeb';
  const MobileComponent = MobileComponents.Dashboard;
  const DesktopComponent = DesktopComponents.Dashboard;

  return (
    <DynamicLayout>
      <Suspense fallback={<LoadingComponent />}>
        {isMobile ? <MobileComponent /> : <DesktopComponent />}
      </Suspense>
    </DynamicLayout>
  );
};

export default Index;
